import ContentLoader from './ContentLoader';
import RectLoader from './RectLoader';
import React from 'react';

const LoadingComp = ({ width, height, backgroundColor, foregroundColor, y = "15" }) => <ContentLoader speed={2} width={width} height={height}
  backgroundColor={backgroundColor || "#f3f3f3"}
  foregroundColor={foregroundColor || "#ecebeb"}
>
  <RectLoader x="0" y={y} rx="3" ry="3" width="100%" height="100%" />
</ContentLoader>;

export default LoadingComp;
